<template>
  <q-page class="q-pa-xl centered-container">
    <div class="row full_width justify-center q-mt-xl q-pt-xl align-center fit fill-height centered-container">
      <div class="col-12">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-5 gt-sm">
            <q-img
              src="/illustrations/customize_account.svg"
              style="max-width: 80%; height: auto"
              class="q-pa-xl"
            />
          </div>

          <div class="col-xs-12 col-sm-12 col-md-7 self-center">
            <q-chip
              class="text-overline q-mb-md"
              color="pastel-yellow"
            >
              {{ $page.props.i18n.tagline }}
            </q-chip>
            <br>
            <span class=" text-h4">{{ $page.props.i18n.title }}</span>
            <p
              class="text-muted q-mt-md q-mb-md"
              v-html="$page.props.i18n.text"
            />

            <q-banner
              class="bg-pastel-blue q-px-md q-mt-lg"
              dense
              style="max-width: fit-content"
            >
              <template v-slot:avatar>
                <q-icon
                  name="las la-info-circle"
                  class="message-box-text"
                  size="sm"
                />
              </template>
              <div
                class="text-caption message-box-text"
                style="font-weight: 400"
                v-html="$page.props.i18n.info"
              />
            </q-banner>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import Layout from '@/layouts/wg_admin.vue';

export default {
  components: {
  },
  layout: Layout,
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
};
</script>
